<kilowant-header [isBuyer]="true" [myKilowant]="(user.isAdvisor)?true:false" [showTtitleAsSecond]="(user.isAdvisor)?true:false" [showAccountList]="false" [title]="(welcomeText)?'Welcome to kilowant':'Add Account'"></kilowant-header>
<div class="overWrapper">
    <div class="wrapperMain mt-40">
        @if (welcomeText) {
        <div class="text" style="margin: auto; height: 100px;">
            <div>Please upload an image or photo of your RI Energy Electricity Bill Page 1. Your information will be used for quotation purposes only.</div>
        </div>
        }
    </div>
    <ol class="wrapperMain kilowant-list">
        <li class="home-step" [class]="(step==1)?'':('inactive'+((step>1)?' with-link':''))" #step1>
            <h3 class="title" #body>
                <span>Upload or Photo P.1 of your Bill</span>
            </h3>
            @if (step>1) {
            <div class="inactive-step" (click)="gotoStep(1)"></div>
            }
            @if (step==1) {
            <div class="form">
                <div class="body" #body>
                    @if (account) {
                    <div class="bill-photo"></div>
                    @if (!loading && !progress) {
                    <div class="progress-tabs">
                        <label class="i_upload link"><br />Upload<input style="display: none;" type="file" name="billImage" class="required" value="" placeholder="Bill Image" (change)="handleFileInput($event)" /></label>
                        <label class="i_camera link"><br />Photo<input type="file" capture="camera" accept="image/*" name="billImage" style="display: none;" value="" placeholder="Bill Image File" (change)="handleFileInput($event)" /></label>
                    </div>
                    }
                    @if (loading || progress) {
                    <div class="progress-bar">
                        <div class="bar">
                            <span class="progress" [style]="'width: '+progressWidth+'%'"></span>
                        </div>
                    </div>
                    }
                    }
                </div>
                <div>&nbsp;</div>
                @if (errorY().showError()) {
                <div class="error-block">{{errorY().error}}</div>
                }
            </div>
            }
        </li>
        <li class="home-step" [class]="(step==2)?'':('inactive'+((step>2)?' with-link':''))" #step2>
            <h3>Complete Account Details</h3>
            @if (step>2) {
            <div class="inactive-step" (click)="gotoStep(2)"></div>
            }
            @if (step==2) {
               <kilowant-account-add-step2 [(account)]="account" [user]="toBeUsedUser" 
                                           (taxCertificateChanged)="setTaxtCertificate($event)"
                                           (deleteTaxExemptCertificateChanged)="setDeleteTaxExemptCertificateChanged($event)"
                                           [byAdvisor]="(user.isAdvisor==null)?false:user.isAdvisor" 
                                           (return)="finishStep2($event)"></kilowant-account-add-step2>
            }
        </li>

        <li class="home-step" [class]="(step==3)?'':('inactive'+((step>3)?' with-link':''))" #step3>
            <h3>Confirm Supply Service Provider</h3>
            @if (step==3) {
            <kilowant-account-add-step3 [(account)]="account" [user]="toBeUsedUser"
                                        [byAdvisor]="(user.isAdvisor==null)?false:user.isAdvisor" 
                                        (existingContractIdChanged)="setExistingContractId($event)"
                                        (existingContractChanged)="setExistingContract($event)"
                                        (return)="finishStep3($event)"></kilowant-account-add-step3>
            }
        </li>
    </ol>
</div>